<template>
  <main>
    <div class="row center-align main">
      <span class="titulo center-align">Saldos</span>
      <div class="col card-panel recargas">
        <span class="subtitulo center-align">Recargatodo</span>
        <span class="saldo center-align">${{recargatodo}}</span>
      </div>
      <div class="col card-panel movimientos">
        <span class="subtitulo center-align">Pagaqui</span>
        <div class="row">
          <div class="col s6 saldoTitle">Movistar:</div> <div class="col s6 saldo">${{pagaquiMovi}}</div>
          <div class="col s6 saldoTitle">Att/Iusa/Une:</div> <div class="col s6 saldo">${{pagaquiIusa}}</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import {getCompanias, getSaldos} from '@/api/api'
  import {recargar} from "@/api/api";

  export default {
    name: "saldos",
    data() {
      return {
        recargatodo:'',
        pagaquiMovi:'',
        pagaquiIusa:'',
      }
    },
    beforeCreate:function(){
      if (localStorage.nivel > 1) return this.$router.push({name:'login'})
      getSaldos().then(res=>{
        console.log(res)
        this.recargatodo = res.data.saldos.recargatodo
        this.pagaquiMovi = res.data.saldos.pagaqui.MOVISTAR
        this.pagaquiIusa = res.data.saldos.pagaqui.IUSA_UNEFON
      }).catch(error=>{
        console.log(error)
      })
    }
  }
</script>

<style scoped>
  .titulo {
    font-size: 2.2em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
    font-weight: lighter;
  }

  .subtitulo {
    font-size: 2em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
  }

  .saldo {
    font-size: 1.8em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
    color: darkgreen;
  }

  .saldoTitle{
    font-size: 1.8em;
    text-align: right;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
  }
  .prefix {
    font-size: 1.4em;
    margin-top: 10px;
  }

  .card-panel {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .recargas{
    width: 45.5%;
    margin-left: 3%;
  }

  .movimientos{
    width: 45.5%;
    margin-left: 3%;
  }

  .main{
    margin-top: 20px;
  }
</style>
